import React, { useCallback, useMemo, useState } from 'react';
import { makeStyles, Button, Divider, Popup, PopupContainer, PopupContent, ExpandMore } from "../../../../index";
import { OrganizationMenuItem } from "./OrganizationMenuItem";
/**
 * maxHeightの計算に用いるポップアップの始点のy座標（px）
 *
 * ダイアログヘッダーの高さ(40px) + Toolbarのpadding-top(20px) + Selectの高さ(40px)
 */
var POPUP_STARTING_POINT = 40 + 20 + 40;
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    button: {},
    popup: {
        // iPadの画面は100vhより狭いケースがあるのでスペースを大きめに取っておく。
        maxHeight: "calc(100vh - " + (POPUP_STARTING_POINT + theme.spacing(10)) + "px)",
    },
    content: {
        width: 568,
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    organizationName: {
        display: 'inline-block',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    expandMore: {
        flexShrink: 0,
    },
}); });
export var OrganizationMenu = function (props) {
    var organizations = props.organizations, selectedOrganization = props.selectedOrganization, onSelectOrganization = props.onSelectOrganization;
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(null), anchorRef = _b[0], setAnchorRef = _b[1];
    var classes = useStyles();
    var handleRef = useCallback(function (ref) { return setAnchorRef(ref); }, []);
    var handleToggle = useCallback(function () { return setOpen(function (prevOpen) { return !prevOpen; }); }, []);
    var handleClose = useCallback(function () { return setOpen(false); }, []);
    // prettier-ignore
    var handleSelectOrganization = useCallback(function (organization) {
        setOpen(false);
        if (organization.id !== (selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id)) {
            onSelectOrganization(organization);
        }
    }, [onSelectOrganization, selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.id]);
    // prettier-ignore
    var clazzes = useMemo(function () { return organizations.filter(function (organization) { return organization.type === 'CLAZZ'; }); }, [organizations]);
    // prettier-ignore
    var groups = useMemo(function () { return organizations.filter(function (organization) { return organization.type === 'GROUP'; }); }, [organizations]);
    return (React.createElement(PopupContainer, { className: classes.root },
        React.createElement(Button, { ref: handleRef, variant: "square", onClick: handleToggle },
            React.createElement("span", { className: classes.organizationName }, selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization.fullName),
            React.createElement(ExpandMore, { className: classes.expandMore })),
        React.createElement(Popup, { open: open, anchorEl: anchorRef, placement: "bottom-start", portal: true, flip: false, className: classes.popup, onClickAway: handleClose },
            React.createElement(PopupContent, { className: classes.content }, clazzes.map(function (clazz) { return (React.createElement(OrganizationMenuItem, { organization: clazz, onClick: handleSelectOrganization, key: clazz.id })); })),
            groups.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { thin: true }),
                React.createElement(PopupContent, { className: classes.content }, groups.map(function (group) { return (React.createElement(OrganizationMenuItem, { organization: group, onClick: handleSelectOrganization, key: group.id })); })))))));
};
